import React, { Component } from 'react';
//import CKEditor from 'ckeditor4-react';
import { isUndefined } from 'lodash';
import { Editor } from '@tinymce/tinymce-react';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  
  editorStyle: {
    // minHeight: 'calc(100vh - 393px)',
    // minHeight: 'calc(100% - 38px)',
    height: 'calc(100% - 38px)',
    '& .cke_chrome' : { 
      border: 'none',
    },
    '& .cke .cke_bottom' : { 
      backgroundColor: 'transparent',
      borderRadius: '0px 0px 0px 10px' 
    },
    '& .cke .cke_top' : { 
      backgroundColor: 'transparent'
      // borderRadius: '0px 0px 0px 10px' 
    },
    '& .cke .cke_inner' : { 
      backgroundColor: 'transparent'
      // borderRadius: '0px 0px 0px 10px' 
    }
    },
});

   class Kommentar extends Component {
       /* state = {
          content: this.props.Body,
          type:isUndefined(this.props.type)?"classic":this.props.type,
        }*/

        state = {
          content: this.props.Body,
          config: {
            toolbar: [ { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike',  '-', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList','-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl' ] },
            { name: 'insert', items: [  'HorizontalRule' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] } ,
            { name: 'styles', items: [ 'FontSize' ] }
            
          ],
          // enterMode: window.CKEDITOR.ENTER_BR,
          removePlugins: 'elementspath',
          extraPlugins: "colorbutton,font,justify",
          width: "100%",
          maxHeight: isUndefined(this.props.height)?"200":this.props.height,
          height : isUndefined(this.props.height)?"200":this.props.height,
          resize_enabled:false,
          font_names :
              'Arial/Arial, Helvetica, sans-serif;' +
              'Times New Roman/Times New Roman, Times, serif;' +
              'Verdana'
          }
        }

        componentDidUpdate=()=>{
          if(this.state.content !== this.props.Body){
            this.setState({
              content: this.props.Body
            })
          }
        }
        /*
      config= {
          toolbar: [ 
          { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike',  '-', 'RemoveFormat' ] },
          { name: 'paragraph', items: [ 'NumberedList', 'BulletedList','-', 'JustifyLeft', 'JustifyCenter', 'JustifyBlock' ] },
          { name: 'insert', items: [  'HorizontalRule' ] }
        ],
        extraPlugins :"colorbutton,font,justify,editorplaceholder",
        width: "100%",
        editorplaceholder: isUndefined(this.props.placeHolder)?"":this.props.placeHolder,
        maxHeight: isUndefined(this.props.height)?"200px":this.props.height,
        height:isUndefined(this.props.height)?"200px":this.props.height,
        resize_enabled:false,
        font_names :
            'Arial/Arial, Helvetica, sans-serif;' +
            'Times New Roman/Times New Roman, Times, serif;' +
            'Verdana'
        
         }*/
      updateContent(newContent) {
        this.props.onchangeHanelEvent(isUndefined(this.props.Meta)?"Body":this.props.Meta,newContent)
      }
    
      onChange=(data)=> {
     //   const newContent = evt.editor.getData();
      //  this.setState({content:newContent})
       // this.props.onchangeHanelEvent("Body",)
       this.props.onchangeHanelEvent(isUndefined(this.props.Meta)?"Body":this.props.Meta,data)
      }
      onBlurHnadle=()=>{
        
      }
      render() {
     // console.log(isUndefined(this.props.height)?"200px":this.props.height)
      const {classes} = this.props
        return (
          <>
           <div className={classes.editorStyle}>
              <Editor
              disabled={isUndefined(this.props.disAbeld)?false:this.props.disAbeld}
		  	tabIndex={1}
        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
			onEditorChange={(value) => {this.onChange(value)}}
			// onChange={(e,v) => {this.onChange(e,v)}}
      onInit={(evt, editor) => {
				// this.myRef.current = editor
      }}
			value={this.props.Body}
			init={{
        readonly : isUndefined(this.props.disAbeld)?0:this.props.disAbeld === true?1:0,
        placeholder: isUndefined(this.props.placeHolder)?"":this.props.placeHolder,
        force_br_newlines : true,
        force_p_newlines : false,
        forced_root_block : '',
				menubar: false,
				inline: false,
				draggable_modal: true,
        relative_urls: false,
				resize: false,
				paste_block_drop: false,
        paste_data_images : false,
        paste_as_text: true,
				branding: false,
        statusbar: false,
				selector: 'textarea',
        browser_spellcheck: true,
        contextmenu: false,
        plugins: 
					'advlist autolink lists link image charmap preview anchor ' +
					'searchreplace visualblocks code fullscreen ' +
					'insertdatetime media table help wordcount table ',
				// table_appearance_options: false,
				font_size_formats: "8px 10px 12px 14px 16px 18px 24px 36px 48px 60px 72px 84px 96px 108px 120px",
				// external_plugins: {
				// 	bubbleBar: "http://www.leofec.com/assets/tinymceBubbleBar.js", // file location
				// },
        maxHeight: isUndefined(this.props.height)?"200":this.props.height,
        height : isUndefined(this.props.height)?"200":this.props.height,
				toolbar: 'undo redo | fontsize  | ' +
				'link fontLight bold italic underline forecolor | bullist numlist alignment outdent indent | image ' +
				`| help `,
				table_sizing_mode: 'responsive ',
				table_column_resizing: 'resizetable',

				font_family_formats: `
					Titillium=Titillium Web, sans-serif;
					Ubuntu=Ubuntu, Arial, sans-serif;
					Lucida Sans Unicode=Lucida Sans Unicode, Lucida Grande, sans-serif;
					Tahoma=Tahoma, Geneva, sans-serif;
					Times New Roman=Times New Roman, Times, serif;
					Trebuchet MS=Trebuchet MS, Helvetica, sans-serif;
					Verdana=Verdana, Geneva, sans-serif;
					Arial=Arial, Helvetica, sans-serif;
					Calibri=Calibri, sans-serif;
					Open Sans=Open Sans, sans-serif;
					Lato=Lato, sans-serif;
					Montserrat=Montserrat, sans-serif;
          Interstate=Interstate;
          Cabin=Cabin
					`,

				toolbar_groups: {
					formatting: {
					  icon: 'format',
					  tooltip: 'Formateringar',
					  items: 'link bold italic underline backcolor forecolor'
					},
					alignment: {
						icon: 'align-left',
						tooltip: 'Text inriktningar',
						items: ' alignleft aligncenter alignright alignjustify'
					}
				  },

				content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
				language_url: process.env.PUBLIC_URL + '/langsTinymce/sv_SE.js',
        language: 'sv_SE',

				//styleselect -- toolbar
				style_formats: [ 
					{ title: '100', format: 'fw100' },
					{ title: '200', format: 'fw200' },
					{ title: '300', format: 'fw300' },
					{ title: '400', format: 'fw400' },
					{ title: '500', format: 'fw500' },
					{ title: '600', format: 'fw600' },
					{ title: '700', format: 'fw700' },
					{ title: '800', format: 'fw800' },
					{ title: '900', format: 'fw900' },
				],
			}}
		/>
          </div>
          {/*
              <CKEditor
              type={this.state.type}
              readOnly={isUndefined(this.props.disAbeld)?false:this.props.disAbeld}
               config={this.config}
               data={this.state.content}
               onChange={evt => this.onChange(evt)}
               onBlur={this.onBlurHnadle}
              />
              */}
          </>
        )
      }
}

export default withStyles(styles)(Kommentar);